// extracted by mini-css-extract-plugin
export var bold = "_yp-0";